function createEl (elType, classes, parent, prepend) {
  const el = document.createElement(elType);

  if (classes) {
    if (Array.isArray(classes)) {
      for (const cls of classes) {
        el.classList.add(cls);
      }
    } else {
      el.classList.add(classes);
    }
  }

  if (parent) {
    if (prepend) {
      parent.prepend(el);
    } else {
      parent.appendChild(el);
    }
  }

  return el;
}

export default createEl;
